import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
    name: 'mascaraCpfCnpj'
})
export class CpfCnpjPipe implements PipeTransform{
   valueFormatado: string;

    transform(value: string){
        if(value){            
            if(value.length === 11){
               this.valueFormatado = value.substring(0,3).concat(".").concat(value.substring(3,6))                                      
                                      .concat(".").concat(value.substring(6,9)).concat("-")
                                      .concat(value.substring(9,11));
            } else if(value.length === 14){
               this.valueFormatado = value.substring(0,2).concat(".").concat(value.substring(2,5))                                      
                                      .concat(".").concat(value.substring(5,8)).concat("/")
                                      .concat(value.substring(8,12)).concat("-")
                                      .concat(value.substring(12,14));
            } 
        }

        return this.valueFormatado;
    }
}


// WEBPACK FOOTER //
// ./src/app/pipes/mascara-cpf-cnpj.pipe.ts